/* eslint-disable no-console */
import axios from 'axios';
import { guid, getUTCDateTime } from '../Components/Common/Util';
import useApiTokens from '../Components/Hooks/useApiTokens';
// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';

/**
 * Sets the default authorization
 * @param {*} token
 */

const customTransformRequest = (data) => {
    return data;
};

class APIClient {
    /**
     * Fetches data from given url
     */
    get = (url, apiTokens, uniqueLinkId, changeUrl) => {
        const guidOf = guid();
        const currentDate = getUTCDateTime(new Date());
        let headers = {
            'x-request-id': guidOf,
            'x-request-dt': currentDate
        };
        let apiUrl = process.env.REACT_APP_API_URL;

        let auth = {};
        if (url === '') {
            apiUrl = `${process.env.REACT_APP_AUTH_URL}/${uniqueLinkId}`;
            headers['Authorization'] = `Basic ${process.env.REACT_APP_AUTH_TOKEN}`;
            headers['x-api-key'] = process.env.REACT_APP_API_KEY;
        } else {
            // const apiTokens = useApiTokens();
            if (apiTokens) {
                headers['Authorization'] = apiTokens['token'];
                headers['x-api-key'] = apiTokens['apiKey'];
            }
            if (changeUrl) {
                // apiUrl = apiUrl?.split('assessments/')[0] + url;
                apiUrl = process.env.REACT_APP_API_BASE_URL + url;
            } else {
                apiUrl += url;
            }
        }
        let response;

        response = axios.get(apiUrl, { headers });
        return response;
    };
    /**
     * post given data to url
     */
    create = (url, apiTokens, data, resourceID, uniqueGuid) => {
        const guidOf = uniqueGuid ? uniqueGuid : guid();
        const currentDate = getUTCDateTime(new Date());
        // const apiTokens = useApiTokens();

        let headers = {
            'x-request-id': guidOf,
            'x-request-dt': currentDate
        };
        if (apiTokens) {
            headers['Authorization'] = apiTokens['token'];
            headers['x-api-key'] = apiTokens['apiKey'];
        }

        return axios.post(`${process.env.REACT_APP_API_URL}${url}`, data, { headers });
    };
    /**
     * Updates data
     */
    update = (url, apiTokens, data) => {
        const guidOf = guid();
        const currentDate = getUTCDateTime(new Date());

        let headers = {
            'x-request-id': guidOf,
            'x-request-dt': currentDate
        };

        if (apiTokens) {
            headers['Authorization'] = apiTokens['token'];
            headers['x-api-key'] = apiTokens['apiKey'];
        }

        return axios.put(`${process.env.REACT_APP_API_URL}${url}`, data, { headers });
    };
    /**
     * Delete
     */
    // delete = (url, config, customizedBaseURL) => {
    //     return axios.delete(customizedBaseURL ? originVal + customizedBaseURL + url : baseURL + url, { ...config });
    // };

    // Patch
    patch = (url, apiTokens, data) => {
        const guidOf = guid();
        const currentDate = getUTCDateTime(new Date());

        let headers = {
            'x-request-id': guidOf,
            'x-request-dt': currentDate
        };

        if (apiTokens) {
            headers['Authorization'] = apiTokens['token'];
            headers['x-api-key'] = apiTokens['apiKey'];
        }
        return axios.patch(`${process.env.REACT_APP_API_URL}${url}`, data, { headers });
    };

    customApiCall = (apiObject, captureGuId, uniqueLinkId, payLoad) => {
        const guidOf = guid();
        const currentDate = getUTCDateTime(new Date());
        captureGuId && captureGuId(guidOf);
        let headers = {
            'x-request-id': guidOf,
            'x-request-dt': currentDate
        };
        let apiUrl = apiObject?.customEndPointUrl ? apiObject?.customEndPointUrl : process.env.REACT_APP_API_URL;
        if (apiObject?.url === '') {
            apiUrl = `${process.env.REACT_APP_AUTH_URL}/${uniqueLinkId}`;
            headers['Authorization'] = `Basic ${process.env.REACT_APP_AUTH_TOKEN}`;
            headers['x-api-key'] = process.env.REACT_APP_API_KEY;
        } else {
            // const apiTokens = useApiTokens();
            if (apiObject?.token) headers['Authorization'] = apiObject?.token;
            if (apiObject?.apiKey) headers['x-api-key'] = apiObject?.apiKey;

            apiUrl += apiObject?.url;
        }
        let response;
        if (apiObject.method === 'GET') {
            response = axios.get(apiUrl, { headers });
        } else if (apiObject.method === 'POST') {
            response = axios.post(apiUrl, payLoad, { headers });
        }

        return response;
    };
}

export { APIClient };
